import { createContext, useContext, ReactNode } from 'react';
import { APIProvider } from '@vis.gl/react-google-maps';

const GoogleMapsContext = createContext<boolean>(false);

interface GoogleMapsProviderProps {
  children: ReactNode;
}

export function GoogleMapsProvider({ children }: GoogleMapsProviderProps) {
  return (
    <APIProvider
      apiKey={import.meta.env.VITE_GOOGLE_MAPS_API_KEY}
      libraries={['marker', 'places']}
      language="en"
    >
      <GoogleMapsContext.Provider value>{children}</GoogleMapsContext.Provider>
    </APIProvider>
  );
}

export function useGoogleMaps() {
  const isLoaded = useContext(GoogleMapsContext);
  if (!isLoaded) {
    throw new Error('useGoogleMaps must be used within a GoogleMapsProvider');
  }
  return { isLoaded: true, loadError: undefined };
}
